import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "bootstrap-daterangepicker/daterangepicker.css";
import { all_routes } from "./router/all_routes";
import "bootstrap-daterangepicker/daterangepicker.css";
import Header from "./Header";
import Swal from "sweetalert2";
import { Select } from "antd";
import { ProductContext } from "../context/AppContext";




const ApplyRescheduleExam = () => {
    const { bookingId, examId } = useParams();

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const authtoken = localStorage.getItem("token");
    const { dataNew, getRegistration } = useContext(ProductContext);
    const [getExamExamData, setGetExamExamData] = useState(null);
    const [filteredExam, setFilteredExam] = useState([]);
  const Regi_id = Number(getRegistration?.data?.id);


    const fetchExamData = () => {
        fetch(`https://api.mirai.healthcare/api/exam-schedule?exam_id=${examId}`, {
            method: "GET",
            headers: {
                Accept: "application/json, text/plain",
                "Content-Type": "application/json;charset=UTF-8",
                "x-auth": `${authtoken}`,
            },
        })
            .then((response) => response.json())
            .then((response) => {
                setGetExamExamData(response);
            })
            .catch((error) => {
                console.error("Fetch error:", error);
            });
    };

    useEffect(() => {
        fetchExamData();
    }, []);

    const [formData, setFormData] = useState({
        exam_date: null,
    });

    const allDate =
        getExamExamData?.message?.examSchedule
            ?.map((cls) => ({
                value: new Date(cls?.exam_date).toISOString().split("T")[0],
                label: new Date(cls?.exam_date).toISOString().split("T")[0],
            }))
            .filter((value, index, self) => index === self.findIndex((t) => t.value === value.value)) || [];

    useEffect(() => {
        if (!getExamExamData || !getExamExamData.message?.examSchedule) return;

        console.log("Updated formData:", formData);

        if (formData.exam_date && formData.exam_date.value) {
            const selectedDate = formData.exam_date.value;
            console.log("Selected Date (After Change):", selectedDate);

            const selectedExams = getExamExamData.message.examSchedule.filter((exam) => {
                const examDate = new Date(exam.exam_date).toISOString().split("T")[0];

                console.log(`Exam Date: ${examDate} | Selected Date: ${selectedDate} | Match: ${examDate === selectedDate}`);

                return examDate === selectedDate;
            });

            setFilteredExam(selectedExams || []);
        } else {
            setFilteredExam(getExamExamData?.message?.examSchedule || []);
        }
    }, [formData.exam_date, getExamExamData]);





    const handleChange = (selectedOption) => {

        const formattedOption =
            typeof selectedOption === "string"
                ? { value: selectedOption, label: selectedOption }
                : selectedOption;

        console.log("Selected Option from Dropdown:", formattedOption);

        setFormData((prevState) => ({
            ...prevState,
            exam_date: formattedOption,
        }));
    };




    const handleSubmit = async (id) => {
        console.log("Exam ID:", id);
        console.log(bookingId, "bookingId")


        if (loading) return;
  setLoading(true);
        try {
            const response = await fetch(
                `https://api.mirai.healthcare/api/exam-booking/reschedule-reexam/${bookingId}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        "x-auth": `${authtoken}`,
                    },
                    body: JSON.stringify({
                        status: 'reschedule',
                        exam_reschedule_id: id,
                        reg_id: Regi_id,
                    }),
                }
            );

            if (response.ok) {
                await Swal.fire({
                    title: "Exam Book Successfully",

                    icon: "success",
                });
                navigate("/examschedule");
            } else {
                const errorData = await response.json();
                alert(`Failed to create enquiry: ${errorData.message}`);
            }
        } catch (error) {
            alert(`Error: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };;

    return (
        <div className="page-wrapper">
            <div className="content background-color_row">
                <Header />
                <h3 className="page-title text-center">Exam Reschedule</h3>
                <div className="row d-flex justify-content-center align-items-center background-color_row_2">
                    <div className="col-md-5">
                        <div className="card card_1">
                            <form className="needs-validation" noValidate 
                            // onSubmit={handleSubmit}
                            >
                                <label className="form-label">Date</label>
                                <Select
                                    className="Exam_date"
                                    options={allDate}
                                    value={formData.exam_date}
                                    placeholder="Select Date"
                                    onChange={handleChange}
                                />




                            </form>
                        </div>
                    </div>
                </div>


                <div className="row mt-4">
                    {filteredExam.length > 0 ? (
                        filteredExam.map((exam) => (
                            <div key={exam.id} className="col-md-4 col-sm-6 mb-2">
                                <div className="card h-100">
                                    <div className="card-header card-buttons">
                                        <h5 className="card-title">Exam Name: {exam.exam_name || "N/A"}</h5>
                                    </div>
                                    <div className="card-body Card_design_1">
                                        <p>
                                            Exam Date: <span>{new Date(exam.exam_date).toISOString().split("T")[0]}</span>
                                        </p>
                                        <p>Start Time: <span>{exam.start_time}</span></p>
                                        <p>End Time: <span>{exam.end_time}</span></p>
                                        <p>
                                            Available Seats: <span>{exam.student_capacity - exam.booked_slot_count}</span>
                                        </p>

                                        {/* <button className="btn btn-primary mt-2" onClick={() => handleSubmit(exam.id)}>
                                            Book Slot
                                        </button> */}
                                         <button
  type="button"
  className="btn btn-primary"
  disabled={loading}
  onClick={() => handleSubmit(exam?.id)}
>
  {loading ? "Booking Exam..." : "Book Slot"}
</button>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="text-center">No exams available for the selected date.</p>
                    )}
                </div>
            </div>
        </div>
    );
};




export default ApplyRescheduleExam;